import helpers from '../helpers';

const indicator = () => {
	const t = (window.pageYOffset + window.innerHeight) / document.body.clientHeight;
	const percent = Math.trunc(t * 100);
	const $homeWrapper = document.querySelector('.home__wrapper');

	document.querySelector('.header__line').style.setProperty('transform', `translateX(${-100 + percent}%)`);

	if ($homeWrapper) {
		if ($homeWrapper
			.getBoundingClientRect().top <= 0) {
			document.querySelector('.header-bar')
				.classList
				.remove('is-hide');
		} else {
			document.querySelector('.header-bar')
				.classList
				.add('is-hide');
		}
	}
};

function init() {
	if (helpers.isMobile()) {
		helpers.$window.on('scroll.header', () => {
			indicator();
		});
	}
}

function destroy() {
	helpers.$window.off('.header');
}

export default {
	init,
	destroy,
};
